/**
 * @author Brendan Magee
 * @desc new pitch form component, used in the pitch modal and in external systems
 * @example <pitch-form type="parentCtrl.pitchType"
 *                      story-id="parentCtrl.storyId"
 *                      platforms="parentCtrl.platforms"
 *                      sites="parentCtrl.sites"
 *                      excluded-destinations="parentCtrl.excludedDestinations"
 *                      submission-success="parentCtrl.method(data)"
 *                      form-type="typeString">
 *          </pitch-form>
 */

import template from './pitchForm.html';

function PitchFormController($log, $window, Pitch) {
  const $ctrl = this;

  const setClearForm = () => {
    $ctrl.formData = {
      targets: [],
      breaking: false,
      note: ''
    };
  };

  this.$onInit = () => {
    this.typeStringToken = $ctrl.type.toUpperCase();
    this.pitchCreate = {
      enable: false,
      success: null
    };

    setClearForm();
  };

  $ctrl.toggleOneTarget = (target) => {
    const indexOfTarget = $ctrl.formData.targets
      .findIndex((existingTarget) => {
        if ($ctrl.type === 'platforms') {
          return existingTarget.id === target.id && existingTarget.site === target.site;
        }

        return existingTarget.id === target.id;
      });

    if (indexOfTarget < 0) {
      $ctrl.formData.targets.push(target);
      $ctrl.updateSelectedPitches($ctrl.formData.targets);
    } else {
      $ctrl.formData.targets.splice(indexOfTarget, 1);
      $ctrl.updateSelectedPitches($ctrl.formData.targets);
    }
  };

  $ctrl.updateTarget = (change) => {
    if ($ctrl.type === 'publications') {
      const targetIndex = $ctrl.formData.targets.findIndex(val => val.id === change.publicationId);
      if (targetIndex < 0) return;
      Object.assign($ctrl.formData.targets[targetIndex], { ...change });
      $ctrl.updateSelectedPitches($ctrl.formData.targets);
    }
  };

  $ctrl.submit = () => {
    $ctrl.pitchCreate.enable = true;
    let targets;

    const payload = {};
    const typeArg = $ctrl.type.slice(0, -1);

    payload.newNote = $ctrl.formData.note;
    payload.breaking = $ctrl.formData.breaking;
    payload.storyId = $ctrl.storyId;
    payload.type = typeArg;

    if ($ctrl.type === 'publications') {
      const { canHoldUntil } = $ctrl.formData;

      targets = $ctrl.formData.targets
        .map(item => ({
          publicationId: item.id,
          sectionId: item.sectionId,
          editionTime: item.editionTime,
          publicationName: item.publicationName,
          canHoldUntil: canHoldUntil ? Math.floor(canHoldUntil / 1000) : null
        }));
    } else {
      targets = $ctrl.formData.targets
        .map(target => ({
          platformPath: target.id,
          website: target.site
        }));
    }

    Pitch.createMultiple(typeArg, payload, targets)
      .then((data) => {
        const result = { data };
        $ctrl.pitchCreate.enable = false;
        $ctrl.pitchCreate.success = true;
        if ($ctrl.type === 'publications') {
          for (let i = 0; i < result.data.length; i += 1) {
            result.data[i].publicationName = targets[i].publicationName;
          }
        }

        if ($ctrl.formType === 'external') {
          result.postMessage = true;
        }

        $ctrl.submissionSuccess({ pitchData: result });
        setClearForm();
      }, (error) => {
        $ctrl.pitchCreate.enable = false;
        $ctrl.pitchCreate.success = false;
        $log.error('PitchFormController submit() error: ', error);
      });
  };

  $ctrl.cancel = () => {
    if ($ctrl.formType === 'external') {
      const postMsgData = {
        eventType: 'cancel'
      };

      $window.parent.postMessage(postMsgData, $window.origin);
    }
  };

  $ctrl.updateSelectedPitches = (pitches) => {
    $ctrl.selectedPitches = Array.from(pitches);
  };
}

const pitchForm = {
  template,
  bindings: {
    type: '<',
    storyId: '<',
    platforms: '<',
    sites: '<',
    excludedDestinations: '<',
    formType: '@',
    submissionSuccess: '&'
  },
  transclude: true,
  controller: 'PitchFormController'
};

const controllerArray = [
  '$log',
  '$window',
  'Pitch',
  PitchFormController
];

export default function (ngModule) {
  ngModule.component('pitchForm', pitchForm);
  ngModule.controller('PitchFormController', controllerArray);
}
